// Core BugMail client (shared logic)
// Extracted from browser SDK

export class BugMailCoreClient {
  constructor(config = {}) {
    this.config = { ...config };
    // config.baseUrl (default: 'http://localhost:8000')
    // config.apiPath (default: '/api/sdk/v1/errors')
    // config.onError (optional callback)
  }

  /**
   * Capture and report an exception to the BugMail backend
   * @param {Error|any} error - The error object
   * @param {Object} context - { headers, payload, ... }
   */
  async captureException(error, context = {}) {
    const isProd = (typeof process !== 'undefined' && process.env?.NODE_ENV === 'production');
    const baseUrl = this.config.baseUrl ||
      (typeof process !== 'undefined' ? (process.env?.BUGMAIL_API_BASE_URL || process.env?.API_BASE_URL || process.env?.BUGMAIL_API_URL) : '') ||
      '';

    if (isProd && !baseUrl) {
      console.warn('[BugMail] BUGMAIL API base URL missing in production. Reporting might default to localhost.');
    }
    const apiPath = this.config.apiPath || '/api/sdk/v1/errors';
    const url = baseUrl.replace(/\/$/, '') + apiPath;
    const headers = {
      'Content-Type': 'application/json',
      ...(context.headers || {})
    };

    // If an API key is provided in the client config, ensure the request
    // includes the expected header unless the caller already supplied one.
    if (this.config && this.config.apiKey) {
      const hasApiKeyHeader = Object.keys(headers).some(h => h.toLowerCase() === 'x-bugmail-api-key');
      if (!hasApiKeyHeader) {
        headers['X-BugMail-API-Key'] = this.config.apiKey;
      }
    }
    const payload = context.payload || {};

    try {
      // Use fetch if available (browser or Node >=18), else fallback
      // Prefer global fetch (browsers, Node 18+). Avoid importing node-fetch in bundlers
      let fetchFn = (typeof fetch !== 'undefined') ? fetch : undefined;
      if (!fetchFn) {
        // In Node environments where fetch is not global, try dynamic import at runtime only
        try {
          // Check if we're actually in Node.js (not a browser with process polyfill)
          // typeof window === 'undefined' is a reliable check for Node vs Browser
          if (typeof window === 'undefined' && typeof process !== 'undefined' && process.versions && process.versions.node) {
            // Only import node-fetch in actual Node.js environments
            const nodeFetchName = 'node' + '-fetch';
            fetchFn = (await import(nodeFetchName)).default;
          } else {
            console.error('[BugMail] fetch is not available in this environment.');
            return;
          }
        } catch (e) {
          console.error('[BugMail] fetch is not available in this environment.');
          return;
        }
      }
      const res = await fetchFn(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errText = await res.text();
        console.error(`[BugMail] Failed to report error: ${res.status} ${res.statusText}\n${errText}`);
        if (typeof this.config.onError === 'function') {
          this.config.onError({ error, payload, status: res.status, statusText: res.statusText, body: errText });
        }
      }
    } catch (err) {
      console.error('[BugMail] Error sending error report:', err);
      if (typeof this.config.onError === 'function') {
        this.config.onError({ error, payload, exception: err });
      }
    }
  }
}
